import type { IOsasLifeStyleFormCustomControlData } from '../../../../../../common/validation/customControls/osasFlex';
import { YesOrNoOrStoppedOrUnknown } from '../../../../../../common/enums/YesOrNoOrStopped';

export const questions: {
    dependentOn?: Partial<IOsasLifeStyleFormCustomControlData>;
    fieldkey: keyof IOsasLifeStyleFormCustomControlData;
    isRequired?: boolean;
    label: string;
    page: number;
    suffix?: string;
    type: 'number' | 'text' | 'radio';
}[] = [
    {
        fieldkey: 'weightInKg',
        label: 'Wat is je huidige gewicht?',
        page: 1,
        suffix: 'kg',
        type: 'number',
    },
    {
        fieldkey: 'lengthInCm',
        label: 'Wat is je lengte?',
        page: 1,
        suffix: 'cm',
        type: 'number',
    },

    { fieldkey: 'isAlcoholUser', isRequired: false, label: 'Drink je alcohol?', page: 2, type: 'radio' },
    {
        dependentOn: { isAlcoholUser: YesOrNoOrStoppedOrUnknown.yes },
        fieldkey: 'daysAWeek',
        isRequired: false,
        label: 'Hoeveel dagen per week drink je meestal alcohol?',
        page: 2,
        suffix: 'dagen',
        type: 'number',
    },
    {
        dependentOn: { isAlcoholUser: YesOrNoOrStoppedOrUnknown.yes },
        fieldkey: 'glassesADay',
        isRequired: false,
        label: 'Hoeveel glazen alcohol drink je op een typische dag wanneer je drinkt?',
        page: 2,
        suffix: 'glazen',
        type: 'number',
    },
    {
        dependentOn: { isAlcoholUser: YesOrNoOrStoppedOrUnknown.stopped },
        fieldkey: 'alcoholStoppedSince',
        isRequired: false,
        label: 'Sinds wanneer ben je gestopt?',
        page: 2,
        type: 'text',
    },

    { fieldkey: 'isSmoker', isRequired: false, label: 'Rook je?', page: 3, type: 'radio' },
    {
        dependentOn: { isSmoker: YesOrNoOrStoppedOrUnknown.yes },
        fieldkey: 'yearsSmoked',
        isRequired: false,
        label: 'Hoeveel jaar rook je?',
        page: 3,
        suffix: 'jaren',
        type: 'number',
    },
    {
        dependentOn: { isSmoker: YesOrNoOrStoppedOrUnknown.yes },
        fieldkey: 'packsADaySmoked',
        isRequired: false,
        label: 'Hoeveel pakjes rook je op een typische dag wanneer je rookt?',
        page: 3,
        suffix: 'pakjes per dag',
        type: 'number',
    },
    {
        dependentOn: { isSmoker: YesOrNoOrStoppedOrUnknown.yes },
        fieldkey: 'isSmokerRemark',
        label: 'Toelichting',
        page: 3,
        type: 'text',
    },
    {
        dependentOn: { isSmoker: YesOrNoOrStoppedOrUnknown.stopped },
        fieldkey: 'smokingStoppedSince',
        isRequired: false,
        label: 'Sinds wanneer ben je gestopt?',
        page: 3,
        type: 'text',
    },
    {
        dependentOn: { isSmoker: YesOrNoOrStoppedOrUnknown.stopped },
        fieldkey: 'isSmokerRemark',
        label: 'Toelichting',
        page: 3,
        type: 'text',
    },

    { fieldkey: 'isDrugUser', isRequired: false, label: 'Gebruik je drugs?', page: 4, type: 'radio' },
    {
        dependentOn: { isDrugUser: YesOrNoOrStoppedOrUnknown.yes },
        fieldkey: 'isDrugUserRemark',
        label: 'Toelichting',
        page: 4,
        type: 'text',
    },
    {
        dependentOn: { isDrugUser: YesOrNoOrStoppedOrUnknown.stopped },
        fieldkey: 'drugUseStoppedSince',
        isRequired: false,
        label: 'Sinds wanneer ben je gestopt?',
        page: 4,
        type: 'text',
    },
    {
        dependentOn: { isDrugUser: YesOrNoOrStoppedOrUnknown.stopped },
        fieldkey: 'isDrugUserRemark',
        label: 'Toelichting',
        page: 4,
        type: 'text',
    },
];
